export default "__VITE_ASSET__8aaa46fb__"